export default "__VITE_ASSET__BAVcarDh__"